// shared/ui/EmptyBox.jsx  (estado vacío beige de las secciones)
import React from 'react';

const EmptyBox = ({ children }) => (
  <div style={{ background: '#F7F1E3', borderRadius: 12, padding: 24, textAlign: 'center', color: '#8a7f68' }}>{children}</div>
);

export default EmptyBox;
